var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgThreeDot = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13854_6265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99869 3.85677C10.9192 3.85677 11.6654 3.11058 11.6654 2.1901C11.6654 1.26963 10.9192 0.523438 9.99869 0.523438C9.07822 0.523438 8.33203 1.26963 8.33203 2.1901C8.33203 3.11058 9.07822 3.85677 9.99869 3.85677Z",
    fill: "#255E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99869 12.1907C10.9192 12.1907 11.6654 11.4446 11.6654 10.5241C11.6654 9.60361 10.9192 8.85742 9.99869 8.85742C9.07822 8.85742 8.33203 9.60361 8.33203 10.5241C8.33203 11.4446 9.07822 12.1907 9.99869 12.1907Z",
    fill: "#255E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99869 20.5228C10.9192 20.5228 11.6654 19.7766 11.6654 18.8561C11.6654 17.9356 10.9192 17.1895 9.99869 17.1895C9.07822 17.1895 8.33203 17.9356 8.33203 18.8561C8.33203 19.7766 9.07822 20.5228 9.99869 20.5228Z",
    fill: "#255E8E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13854_6265"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.523438)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgThreeDot, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/three-dot.40e43b6d.svg";
export { ForwardRef as ReactComponent };